import { useSelector } from 'react-redux';

import { getOrchestratorNid } from '../../store/slices/domainOrchestratorPricingCommittee.slice';
import { InProgressStepsCards } from './InProgressStepsCards';

export const InProgressStepsCardsByNid = () => {
  const nid = useSelector(getOrchestratorNid);
  if (!nid) return null;
  return <InProgressStepsCards nid={nid} />;
};
